export default "__VITE_ASSET__b1f7bbb6__"